import { Component } from '@angular/core';
import { IonicPage, NavController, ToastController , ViewController, AlertController} from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';
//import { HomePage } from '../../pages/pages';
import { User } from '../../providers/user';

import { TranslateService } from '@ngx-translate/core';
import { Country } from '../../models/country';
import { Countries } from '../../providers/providers';

@IonicPage({
  name: 'signup',
  segment: 'signup',
  priority: 'high'
})
@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html'
})
export class SignupPage {
  // The account fields for the login form.
  // If you're using the username field with or without email, make
  // sure to add it to the type
  currentItems: Country[];
  account: { firstname: string, lastname: string, email: string, profession: string, password: string, confirm_password: string, title: string } = {
    firstname: '',
    lastname: '',
    email: '',
    profession: '1',
    password: '',
    confirm_password: '',
    title: '1'
  };

  submitClient: boolean = false;
  isReadyToSave: boolean;

  item: any;

  form: FormGroup;

  // Our translated text strings
  //private signupErrorString: string;

  constructor(public navCtrl: NavController,public user: User,public toastCtrl: ToastController,
              public translateService: TranslateService, formBuilder: FormBuilder, public viewCtrl: ViewController, public items: Countries, public alertCtrl: AlertController) {
                
    this.currentItems = this.items.query();
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.form = formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', this.emailOrEmpty],
      profession_id: ['',Validators.required],
      password: ['',Validators.required],
      confirm_password: ['',Validators.required],
      title_id: ['1'],
      country_id: ['13']
    });

    // Watch the form for changes, and
    this.form.valueChanges.map((val) => {
      // remove the trailing spaces from first name and last name
      val.first_name = val.first_name.trim();
      val.last_name = val.last_name.trim();
      return val;
  })
    .subscribe((v) => {
      this.isReadyToSave = this.form.valid;
    });
    
  }


  onCountryChange(selectedValue: any) {
    let restrictedCountries = ["16","19","22","38","52","55","138","226"]
    //console.log(selectedValue);
    if(restrictedCountries.indexOf(selectedValue)>0){
      this.isReadyToSave = false;
      this.presentAlert()
    }
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      subTitle: 'Unfortunately NovoPysch is not available in your country. North American users can gain access via betterworldhealthcare.com',
      buttons: ['Ok']
    });
    alert.present();
  }

  done() {
    if (!this.form.valid) { return; }
    this.viewCtrl.dismiss(this.form.value);
  }

  openTerms(){
    window.open("https://novopsych.com/terms-conditions-privacy/","_blank","location=true");
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    return control.value === '' ? null : Validators.email(control);
}

  // doSignup() {
  //   // Attempt to login in through our User service
  //   this.user.signup(this.account).subscribe((resp) => {
  //     this.navCtrl.push(HomePage);
  //   }, (err) => {

  //     this.navCtrl.push(HomePage); // TODO: Remove this when you add your signup endpoint

  //     // Unable to sign up
  //     let toast = this.toastCtrl.create({
  //       message: this.signupErrorString,
  //       duration: 3000,
  //       position: 'top'
  //     });
  //     toast.present();
  //   });
  // }
}


// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts